import React, { useMemo } from 'react';
import ContentTypeFactory from './factory';
import parseStorageHtml from './parseStorageHtml';

export default function PageBuilder({ html }) {
    const data = useMemo(() => parseStorageHtml(html), [html]);
    return data.children.map((child, i) => {
        return (
            <div key={i}>
                <ContentTypeFactory data={child} />
            </div>
        );
    });
}
